import React from 'react';
import { Typography } from 'antd';

function RevisitIntervalFooter() {
  return (
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
      Control how often your sitemaps are checked for updated. <br /> Faster intervals mean quicker SEO impact.
    </Typography.Text>
  );
}

export default RevisitIntervalFooter;
